import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import axios from "../common/axios";

const StudentCompetitionsWidget = props => {
    const {className} = props;
    const {user, setUser} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const [isLoading, setLoading] = useState(true);
    const [openStudentCompetitions, setOpenStudentCompetitions] = useState([]);

    const loadOpenStudentCompetitions = () => {
        axios.get('/web/ui/competition/studentOpenCompetitions')
            .then(response => {
                setOpenStudentCompetitions(response.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        if(user !== undefined && user.student) {
            loadOpenStudentCompetitions();
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#competition-icon"></use>
                    </svg>
                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/studentCompetitions'}>
                        <span>Active {brandConfig.competitionsName}</span>
                    </ShortcutLink>
                </div>
            }
            className={className}
            isLoading={isLoading}>
            <div className={'ch-dashboard-blk-body'}>
                {openStudentCompetitions.length > 0 &&
                    <table style={{width: '100%'}} className={'ch-dashboard-list ch-list'}>
                        <tbody>
                        <tr>
                            <th>{brandConfig.competitionName}</th>
                            <th>Assigned</th>
                            <th>Expiry</th>
                        </tr>
                        {openStudentCompetitions.map((studentCompetition, index) => (
                            <tr key={studentCompetition.competitionId}>
                                <td>
                                    <ShortcutLink className="ch-highlight" shortcutUrl={'/web/ui/view/studentCompetitions'}>
                                        {studentCompetition.competitionName ? studentCompetition.competitionName : studentCompetition.conceptName}
                                    </ShortcutLink>
                                </td>
                                <td>{user.dateFormat.format(studentCompetition.assignedDate)}</td>
                                <td>{user.dateFormat.format(studentCompetition.endDate)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                }
                {openStudentCompetitions.length == 0 &&
                    <div className="ch-list-item-disabled">No active {brandConfig.competitionsName.toLowerCase()}</div>
                }
            </div>
        </DashboardWidget>
    )
}

export default StudentCompetitionsWidget;